import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './LoginScreen.css';
import { auth } from '../firebase'; // Adjust path if needed
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

function LoginScreen() {
  const navigate = useNavigate();
  
  // Local state for email/password
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  // Handle email/password login
  const handleSubmit = async (e) => {
    e.preventDefault(); // prevent form refresh
    try {
      // Attempt Firebase sign-in
      await signInWithEmailAndPassword(auth, email, password);
      // If successful, navigate to /home (or wherever you want)
      navigate('/home');
    } catch (error) {
      alert(error.message);
      console.error('Login error:', error);
    }
  };

  // Handle Google Sign-In (optional)
  const handleGoogleSignIn = async () => {
    const provider = new GoogleAuthProvider();
    try {
      await signInWithPopup(auth, provider);
      navigate('/home');
    } catch (error) {
      alert(error.message);
      console.error('Google Sign-In error:', error);
    }
  };

  return (
    <div className="login-container">
      <img 
        src="logo.jpg" 
        alt="Operation Border Lights" 
        className="login-logo"
      />

      <h2 className="login-title">LOGIN</h2>

      {/* Email/Password Form */}
      <form className="login-form" onSubmit={handleSubmit}>
        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          placeholder="Email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        <label htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          placeholder="Password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />

        <button type="submit">Login</button>
      </form>

      {/* Optional Google Sign-In Button */}
      <button 
        style={{ marginTop: '10px' }} 
        onClick={handleGoogleSignIn}
      >
        Sign in with Google
      </button>

      <div className="register-hint">
        <span className="no-account">No Account?</span>{' '}
        <Link to="/registration" className="create-account">
          Create Account
        </Link>
      </div>
    </div>
  );
}

export default LoginScreen;
